import React from 'react';
import { Segment } from 'semantic-ui-react';

import Data from './Data';

const PessoasSidebar = (props) => {
  return (
    <Segment.Group raised>
      <Data {...props} />
    </Segment.Group>
  );
};

export default PessoasSidebar;
